import React from 'react';

export default function EduOpsLogo({ size = "md", className = "" }) {
  const sizes = {
    sm: "h-6 w-6",
    md: "h-8 w-8",
    lg: "h-12 w-12"
  };

  return (
    <div className={`relative flex items-center justify-center ${sizes[size]} ${className}`}>
      <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full drop-shadow-glow">
        {/* Hexagonal Shield Base */}
        <path 
          d="M50 5L90 25V75L50 95L10 75V25L50 5Z" 
          className="fill-blue-600/20 stroke-blue-500" 
          strokeWidth="4"
        />
        {/* Stylized Book/Bell Notch */}
        <path 
          d="M35 35H65V65C65 73.2843 58.2843 80 50 80C41.7157 80 35 73.2843 35 65V35Z" 
          className="fill-orange-500 shadow-lg"
        />
        {/* Book Lines (Pages) */}
        <path d="M42 45H58" stroke="white" strokeWidth="3" strokeLinecap="round" />
        <path d="M42 53H58" stroke="white" strokeWidth="3" strokeLinecap="round" />
        {/* Top Accent */}
        <circle cx="50" cy="20" r="5" className="fill-blue-400 animate-pulse" />
      </svg>
    </div>
  );
}